import React from "react";
import copartLogo from "../assets/copart-logo.svg"; 
import userIcon from "../assets/user.svg";     

export default function Header() {
  return (
    <>
      
      <div className="flex items-center justify-between bg-blue-700 h-[60px] px-6">
        <img src={copartLogo} alt="Copart" className="h-10" />
        <img src={userIcon} alt="User" className="h-8 w-8" />
      </div>
      
      
    </>
  );
}